export default __webpack_public_path__ + "static/media/close.238385a5.svg";